import styled from 'styled-components'

/** An import row's leading half: its status pill, then who sent what. */
export const ImportRowLabel = styled.span`
	display: inline-flex;
	align-items: center;
	gap: 8px;
	min-width: 0;
`
